module.exports = __webpack_public_path__ + "img/电梯动画6.4473009c.png";